module.exports = __webpack_public_path__ + "img/pr-6.4a5a60ce.png";